import { Component, Input, SimpleChange, OnChanges } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { ModalController, Platform } from '@ionic/angular';
import { EvmChain, EvmTransactionData } from '@moralisweb3/evm-utils';
import { environment } from '../../../environments/environment';
import { MoralisService } from '../../angular-wallet-base/services/moralis.service';
import { isPlatformBrowser } from '../../angular-wallet-base/utils';
import { TransactionDetailMoralisModalComponent } from './transaction-detail-modal/transaction-detail-modal.component';

@Component({
  selector: 'app-paginated-transactions',
  templateUrl: './transaction-history-moralis.component.html',
  styleUrls: ['./transaction-history-moralis.component.scss'],
})
export class PaginatedTransactionsComponent {
  @Input() walletAddress: string;
  @Input() chain: EvmChain;

  blockExplorerDomain;
  transactions: EvmTransactionData[];
  limit = 15;
  cursor = null;
  total = 0;
  page = 0;
  page_size = 0;
  options: InAppBrowserOptions = {
    location: 'no', // Or 'no'
    hidden: 'no', // Or  'yes'
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes', // Android only ,shows browser zoom controls
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no', // Android only
    closebuttoncaption: 'Close', // iOS only
    toolbar: 'yes', // iOS only
    toolbarposition: 'top', // iOS only
    enableViewportScale: 'no', // iOS only
    allowInlineMediaPlayback: 'no', // iOS only
    presentationstyle: 'fullscreen', // iOS only
    fullscreen: 'yes', // Windows only
  };
  constructor(private moralisService: MoralisService, private platform: Platform, private inappBrowser: InAppBrowser, private modalController: ModalController) {}

  async ngOnInit() {
    if(this.chain) {
      this.blockExplorerDomain =
        this.chain?.apiId == EvmChain.AVALANCHE?.apiId
          ? environment.EXTERNAL_APIS.EXPLORERS.find((explorer) => explorer.id == 'avax-main')?.API_EXPLORER
          : environment.EXTERNAL_APIS.EXPLORERS.find((explorer) => explorer.id == 'avax-test')?.API_EXPLORER;
    }
    if(this.walletAddress) {
      const transactionHistory = await this.moralisService.getTransactionHistory(this.walletAddress, this.chain, this.limit);
      this.transactions = transactionHistory.result;
      this.total = transactionHistory.total;
      this.page = transactionHistory.page;
      this.page_size = transactionHistory.page_size;
    }
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    const inputValueChange = changes['inputValue'];
    if (inputValueChange) {
      this.refreshTransactions();
    }
    const chainChange = changes['chain'];
    if (chainChange) {
      this.blockExplorerDomain =
        this.chain?.apiId == EvmChain.AVALANCHE?.apiId
          ? environment.EXTERNAL_APIS.EXPLORERS.find((explorer) => explorer.id == 'avax-main')?.API_EXPLORER
          : environment.EXTERNAL_APIS.EXPLORERS.find((explorer) => explorer.id == 'avax-test')?.API_EXPLORER;
      this.refreshTransactions();
    }
  }

  async refreshTransactions() {
    this.page = 0;
    this.transactions = [];

    const transactionHistory = await this.moralisService.getTransactionHistory(this.walletAddress, this.chain, this.limit);
    this.transactions = transactionHistory.result;
    this.total = transactionHistory.total;
    this.page = transactionHistory.page;
    this.page_size = transactionHistory.page_size;
  }

  openUrlToExplorer(txHash: string) {
    if(isPlatformBrowser(this.platform)) {
      window.open(this.blockExplorerDomain + '/tx/' + txHash, '_blank');
    } else {
      this.platform.ready().then(() => {
        this.inappBrowser.create(this.blockExplorerDomain + '/tx/' + txHash, '_system', this.options);
      });
    }
  }

  async loadMoreTransactions(event) {
    if (this.page * this.limit >= this.total) {
      event.target.complete();
      return;
    }

    this.page++;

    const transactionHistory = await this.moralisService.getTransactionHistory(this.walletAddress, this.chain, this.limit);
    this.transactions.push(...transactionHistory.result);
    event.target.complete();
  }

  async goToTransactionDetails(transaction: EvmTransactionData) {
    const modal = await this.modalController.create({
      component: TransactionDetailMoralisModalComponent,
      componentProps: {
        transaction,
        blockExplorerUrl: this.blockExplorerDomain + '/tx/' + transaction.hash
      }
    });
    return await modal.present();
  }
}
